import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { registerUser } from '../../../react-cognito';
import { NotificationManager } from 'react-notifications';
import { Loader } from '../../../components/loader';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

import { createTreatment, fetchCalculations } from '../../../actions/addTreatments'
import { fetchMedicalRecords } from '../../../actions/medicalRecords';
const $ = window.$;
const initialState = {
    currentFormNotValid: false,
    CalculationId: '',
    MedicalRecordId: '',
    start_date: moment(),
    end_date: moment(),
    minDuration: '',
    maxDuration: '',
    dosage: '',
    dosageUnit: '',
    petWeight: '',
    loading: false,
}
let formdata = {};
class NewFormula extends React.Component {
    constructor(props) {
        super(props);
    }

    state = initialState;

    submit = (event) => {
        event.preventDefault();
        this.setState({loading: true});
        if(this.validateForm()){
            let data = Object.values(formdata).map(key=>{
                if(key!==null) {
                    return true;
                }
                else{
                    return false;
                }
            });

            if(!data.includes(false)){              
                this.props.createTreatment(formdata);
            }
            else{
                this.setState({currentFormNotValid: true});
                this.setState({loading: false});
                NotificationManager.warning("Please check input details again.");  
            }
        }
    }
    validateForm(){
        const data= {
            PetShopId: this.props.petShop.currentPetshop.id,
            CalculationId: this.state.CalculationId.toString().trim().length > 0?this.state.CalculationId:null,
            MedicalRecordId: this.state.MedicalRecordId.toString().trim().length > 0?this.state.MedicalRecordId:null,
            start_date: moment(this.state.start_date).isValid ? moment(this.state.start_date).format("MM/DD/YYYY"):null,
            end_date: moment(this.state.end_date).isAfter(this.state.start_date,'day')?moment(this.state.end_date).format("MM/DD/YYYY"):null,
            weight: this.state.petWeight.toString().trim().length > 0?this.state.petWeight:null,
        };
        formdata = Object.assign({},data);
        return true;
        
    }
    changeVal = (event) => {
        this.setState({[event.target.name]: event.target.value})
    }

    changeCal = (selected) => {
        this.setState({CalculationId: selected.value});
    }
    changeWeight = (event)=>{
        this.setState({[event.target.name]: event.target.value})
    }
    changePet = (selected) => {
        this.setState({MedicalRecordId: selected.value})
        this.props.pets.medicalRecords.map(p => {
            if(p.id === selected.value) {
                this.setState({petWeight: p.weight, petBday: p.date_of_birth, petAPath: p.avatar_path, petAName: p.avatar_file_name, petSold: (p.Contract ? true : false)});
            }
        })
    }

    calculateDosage = () => {
        for(let c of this.props.calculators) {
            if(this.state.CalculationId === c.id) {
                let dosage = '';
                if(c.calculationType === 'Formula') {
                    dosage = (parseFloat(c.doseMg) / parseFloat(c.strengthMg) * parseFloat(c.strengthMl)) * (parseFloat(this.state.petWeight) / parseFloat(c.doseLb));
                    this.setState({dosage: dosage.toFixed(2) + ' ml ', dosageUnit: c.doseTimes + 'x a day', strength: c.strengthMg + 'mg/' + c.strengthMl + 'ml', dose: c.doseMg + 'mg/' + c.doseLb + 'lb ' + c.doseTimes + 'x a day', cType: 'Formula'});
                }
                if(c.calculationType === 'Dosage') {
                    dosage = (parseFloat(c.dosageMl)) * (parseFloat(this.state.petWeight) / parseFloat(c.dosageLb));
                    this.setState({dosage: dosage.toFixed(2) + ' ml ', dosageUnit: '', dosageR: c.dosageMl + 'ml/' + c.dosageLb + 'lb', cType: 'Dosage'});
                }
                if(c.calculationType === 'Tablet') {
                    dosage = (parseFloat(c.doseMg) / parseFloat(c.strengthMg)) * parseFloat(this.state.petWeight);
                    if(c.doseType === 'Kg') {
                        dosage = dosage * 0.454;
                    }
                    this.setState({dosage: dosage.toFixed(2) + ' tab ', dosageUnit: c.doseTimes + 'x a day', strength: c.strengthMg + 'mg/tab', dose: c.doseMg + 'mg/' + (c.doseType === 'Lb' ? 'lb ' : 'kg ') + c.doseTimes + 'x a day', cType: 'Tablet'});
                }
                this.setState({minDuration: c.minDuration, maxDuration: c.maxDuration});
            }
        }
    }

    calcEndDate = (event) => {
        let startDate = moment(this.state.start_date,'DD/MM/YYYY');
        let endDate = moment(startDate).add(event.target.value, 'days');
        this.setState({[event.target.name]:event.target.value});
        this.setState({end_date:endDate,duration:event.target.value});
    }

    changeStartDate = (value) => {
        this.setState({ start_date: value })
    }

    calculateDuration = () => {
        let duration = this.state.end_date.diff(this.state.start_date, 'days') + ' days';
        this.setState({duration: duration});
    }

    resetState = () => {
        this.setState(initialState);
        this.props.fetchCalculations();
        this.props.fetchMedicalRecords();
    }

    closeModal = () => {
        $('#new_treatment').modal('hide');
        this.resetState();
    }

    submitFormula = (event) => {
        event.preventDefault();
        this.setState({loading: true});
        const attr = {
            PetShopId: this.props.petShop.currentPetshop.id,
            CalculationId: this.state.CalculationId,
            MedicalRecordId: this.state.MedicalRecordId,
            start_date: this.state.start_date,
            end_date: this.state.end_date,
        }

        this.props.createTreatment(attr);

    }

    componentWillReceiveProps = (nextProps) => {  
        if(nextProps.pets && nextProps.pets.medicalRecords && nextProps.pets.medicalRecords.length >0 && this.props.pets.medicalRecords !== nextProps.pets.medicalRecords) {
            let options = [];
            let pets = nextProps.pets.medicalRecords;
            for(let p of pets) {
                if(p.status !== 'Draft')
                    options.push({label: p.pet_id, value: p.id});
            };
            this.setState({pets: options});
        }

        if(this.props.calculators !== nextProps.calculators && nextProps.calculators.length>0) {
            let options = [];
            nextProps.calculators.map(p => {
              options.push({label: p.treatmentName, value: p.id});
            });
            this.setState({calculators: options});
            this.setState({CalculationId: nextProps.calculators[0].id});
        }
    
        if(this.props.setTreatments !== nextProps.setTreatments) {
            this.resetState();
            this.setState({loading: false});
            this.closeModal();
            NotificationManager.success("Treatment added successfully");
        }
        if(this.props.setTreatmentsError !== nextProps.setTreatmentsError) {
            this.resetState();
            this.setState({loading: false});
            this.closeModal();
            NotificationManager.error("Failed to add treatment.");
        }
    
    }

    componentDidMount = () => {
        this.props.fetchCalculations();
        this.props.fetchMedicalRecords();
        this.calculateDuration();
    }

    componentDidUpdate = (prevProps, prevState) => {

        if(prevState.pets !== this.state.pets && this.state.pets.length > 0) {
            this.changePet({value: this.state.pets[0].value});
        }

        if(prevState.CalculationId !== this.state.CalculationId || prevState.petWeight !== this.state.petWeight) {
            this.calculateDosage();
        }

        if(prevState.start_date !== this.state.start_date || prevState.end_date !== this.state.end_date) {
            this.calculateDuration();
        }
    }

    render() {
        const {CalculationId, MedicalRecordId, start_date, end_date, calculators, minDuration, maxDuration, pets, petWeight, dosage, dosageUnit, duration, cType, strength, dose, dosageR, petAName, petAPath, petBday, petSold,treat_duration} = this.state;

        return (
            <div className="modal fade show" id="new_treatment" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <form onSubmit={this.submit} className="m-form m-form--label-align-left- m-form--state-">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">New Medicating</h5>
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-xl-8 offset-xl-2">
                                        <div className="form-group m-form__group row">
                                            <label className="col-lg-4 col-form-label">Medication:</label>
                                            <div className="col-lg-8">
                                                <Select options={calculators} value={CalculationId} name="CalculationId" onChange={this.changeCal} placeholder="Select the calculator" />
                                                <span className={formdata.CalculationId===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please select a calculator</span>
                                            </div>
                                        </div>
                                        <div className="form-group m-form__group row">
                                            <label className="col-lg-4 col-form-label">Pet Id:</label>
                                            <div className={petSold ? "col-lg-6" : "col-lg-8"}>
                                                <Select options={pets} value={MedicalRecordId} name="MedicalRecordId" onChange={this.changePet} placeholder="Select the pet" />
                                                <span className={formdata.MedicalRecordId===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please select the pet id</span>
                                            </div>
                                            {petSold &&
                                                <div className="col-lg-2">
                                                    <span className="m-badge m-badge--danger m-badge--wide mt-2">Sold</span>
                                                </div>
                                            }
                                        </div>
                                        <div className="form-group m-form__group row">
                                            <label className="col-lg-4 col-form-label">Weight:</label>
                                            <div className="col-lg-4 input-group">
                                                <input type="number" value={petWeight} name="petWeight" onChange={this.changeWeight} className="form-control m-input" />
                                                <div className="input-group-append">
                                                    <span className="input-group-text" id="basic-addon2">Lb</span>
                                                </div>
                                                <span className={formdata.petWeight===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please enter pet weight</span>
                                            </div>
                                        </div>
                                        <div className="form-group m-form__group row">
                                            <label className="col-lg-4 col-form-label">Start date:</label>
                                            <div className="col-lg-4">
                                                <DatePicker selected={moment(start_date).toDate()} value={start_date} onChange={ this.changeStartDate } onSelect={ this.changeStartDate } />
                                                <span className={formdata.start_date===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please select the date of treatment starts</span>
                                            </div>
                                            {/* <div className="col-lg-4">
                                                <DatePicker selected={end_date} value={end_date} onChange={ this.changeEndDate } onSelect={ this.changeEndDate } />
                                                <span className={formdata.end_date===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please select the date of treatment ends</span>
                                            </div> */}
                                        </div>
                                        <div className="form-group m-form__group row">
                                            <label className="col-lg-4 col-form-label">Duration(days):</label>
                                            <div className="col-lg-4">
                                            <input type="number" value={treat_duration} name="treat_duration" onChange={this.calcEndDate} className="form-control m-input" />
                                                <span className={formdata.end_date===null&&this.state.currentFormNotValid?'m-form__help_danger':'m-form__help'}>Please enter treatment duration in days.</span>
                                            </div>
                                        </div>
                                        <div className="form-group m-form__group row">
                                            <label className="col-lg-4 col-form-label"></label>
                                            <div className="col-lg-8 m--align-center">
                                                <h6 className="m--font-warning">Recommended duration: <span className="m--font-danger">{minDuration} - {maxDuration} days</span></h6>
                                                
                                            </div>
                                        </div>
                                        <div className="form-group m-form__group row justify-content-center">
                                            <div className="m-portlet col-md-12">
                                                <div className="m-portlet__body  m-portlet__body--no-padding">
                                                    <div className="row m-row--no-padding m-row--col-separator-xl">
                                                        
                                                        <div className="col-md-6 col-sm-12 widget-border-bottom">
                                                            <div className="m-widget24">
                                                                <div className="m-widget24__item mt-4 mb-4 row">
                                                                    <h4 className="m-widget24__title-custom justify-content-center col-md-12">
                                                                        <span className="m-topbar__userpic">
                                                                            <img src={process.env.REACT_APP_S3_PATH + '/' + petAPath + '/' + petAName} className="m--img-rounded m-width-58" alt="" />
                                                                        </span>
                                                                    </h4>
                                                                </div>
                                                                <div className="m-widget24__item justify-content-center row">
                                                                    <h4 className="m-widget24__title-custom pr-2">
                                                                        Weight: 
                                                                    </h4>
                                                                    <span className="m-widget24__stats-custom m--font-brand">
                                                                        {petWeight} lb
                                                                    </span>
                                                                </div>
                                                                <div className="m-widget24__item justify-content-center dose-times mb-4 row">
                                                                    <h4 className="m-widget24__title-custom pr-2">
                                                                        Birthday: 
                                                                    </h4>
                                                                    <h4 className="m-widget24__title-custom">
                                                                        {petBday}
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 col-sm-12 widget-border-bottom">
                                                            <div className="m-widget24">
                                                                <div className="m-widget24__item mt-4 mb-4 row">
                                                                    <h4 className="m-widget24__title-custom justify-content-center col-md-12">
                                                                        <i className="la la-tint"></i>
                                                                    </h4>
                                                                </div>
                                                                <div className="m-widget24__item justify-content-center row">
                                                                    <h4 className="m-widget24__title-custom pr-2">
                                                                        Dosage: 
                                                                    </h4>
                                                                    <span className="m-widget24__stats-custom m--font-brand">
                                                                        {dosage}
                                                                    </span>
                                                                </div>
                                                                <div className="m-widget24__item mb-4 row">
                                                                    <h2 className="m-widget24__title-custom dose-times col-md-12">
                                                                        {dosageUnit}
                                                                    </h2>
                                                                </div>
                                                            </div>
                                                        </div>
                                                                                                                
                                                    </div>
                                                    <div className="row m-row--no-padding m-row--col-separator-xl">
                                                        
                                                        <div className="col-md-6 col-sm-12">
                                                            <div className="m-widget24">
                                                                <div className="m-widget24__item mt-4 mb-4 row">
                                                                    <h4 className="m-widget24__title-custom justify-content-center col-md-12">
                                                                        <i className="la la-clock-o"></i>
                                                                    </h4>
                                                                </div>
                                                                <div className="m-widget24__item justify-content-center row">
                                                                    <h4 className="m-widget24__title-custom pr-2">
                                                                        Duration: 
                                                                    </h4>
                                                                    <span className="m-widget24__stats-custom m--font-brand">
                                                                        {duration}
                                                                    </span>
                                                                </div>
                                                                <div className="m-widget24__item justify-content-center dose-times mb-4 row">
                                                                    <h4 className="m-widget24__title-custom pr-2">
                                                                        Recommended: 
                                                                    </h4>
                                                                    <h4 className="m-widget24__title-custom">
                                                                        {minDuration} - {maxDuration} days
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-6 col-sm-12">
                                                            <div className="m-widget24">
                                                                <div className="m-widget24__item mt-4 mb-4 row">
                                                                    <h4 className="m-widget24__title-custom justify-content-center col-md-12">
                                                                        <i className="la la-medkit"></i>
                                                                    </h4>
                                                                </div>
                                                                <div className="m-widget24__item justify-content-center row">
                                                                    <h4 className="m-widget24__title-custom pr-2">
                                                                        {cType === 'Dosage' ? 'Dosage Ratio' : 'Strength'}: 
                                                                    </h4>
                                                                    <span className="m-widget24__stats-custom m--font-brand">
                                                                        {cType === 'Dosage' ? dosageR : strength}
                                                                    </span>
                                                                </div>
                                                                {cType !== 'Dosage' &&
                                                                    <div className="m-widget24__item justify-content-center dose-times mb-4 row">
                                                                        <h4 className="m-widget24__title-custom pr-2">
                                                                            Dose: 
                                                                        </h4>
                                                                        <h4 className="m-widget24__title-custom">
                                                                            {dose}
                                                                        </h4>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                {this.state.loading == false ?
                                    <div>
                                        <button type="button" className="btn btn-secondary m-btn--pill mx-2" onClick={this.closeModal}>Close</button>
                                        <button type="submit" className="btn btn-primary m-btn--pill">Submit</button>
                                    </div>
                                :
                                    <div className="center-row">
                                        <Loader size={50} />
                                    </div>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}



const mapStateToProps = state => ({
    user: state.cognito.user,
    petShop: state.petShopReducer,
    setTreatments: state.addFormulaReducer.setTreatments,
    calculators: state.addFormulaReducer.calculations,
    pets: state.medicalRecordsReducer.mRecords,
});
  
const mapDispatchToProps = dispatch => ({
    createTreatment: (attrs) => {
        dispatch(createTreatment(attrs));
    },
    fetchCalculations: () => {
        dispatch(fetchCalculations());
    },
    fetchMedicalRecords: () => {
        dispatch(fetchMedicalRecords());
    },
})
  
  
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewFormula));